import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

export default function RefitManagement() {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const services = [
    'Refit planning and project scoping',
    'Shipyard and contractor selection',
    'Budget development and cost control',
    'Technical oversight and progress monitoring',
    'Scheduling and milestone management',
    'Quality control, testing, and project close-out'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation isVisible={isMenuVisible} setIsVisible={setIsMenuVisible} />
      
      {/* Hero Section */}
      <section className="relative h-screen w-full flex items-center justify-center">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src="https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/084cfd104140998080a7be47c4b14c1b.jpeg"
            alt="Yacht refit in progress"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 text-center px-8 max-w-5xl mx-auto">
          <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl text-white mb-8 tracking-tight">
            Refit Management
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed font-light">
            Strategic oversight to enhance performance, comfort, and long-term value.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-32 px-8 lg:px-16 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="w-20 h-px bg-black mb-8"></div>
          <p className="text-lg md:text-xl text-gray-800 leading-relaxed mb-8">
            SYG Yachts offers expert refit management services for owners seeking to upgrade, modernize, or reposition their yachts. From cosmetic enhancements to complex technical refits, we manage each project with precision, accountability, and a clear focus on outcomes.
          </p>
          <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
            Our team acts as the central point of coordination, ensuring the refit is executed efficiently, on budget, and to the required standard.
          </p>
        </div>
      </section>

      {/* Scope of Services */}
      <section className="py-32 px-8 lg:px-16 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <div className="mb-20">
            <div className="w-20 h-px bg-black mb-8"></div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-black leading-tight mb-12">
              Scope of Services
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {services.map((service, index) => (
              <div key={index} className="flex items-start gap-6">
                <div className="w-2 h-2 bg-black mt-3 flex-shrink-0"></div>
                <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                  {service}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Value-Driven Approach */}
      <section className="py-32 px-8 lg:px-16 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <div className="w-20 h-px bg-black mb-8"></div>
            <h2 className="font-serif text-4xl md:text-5xl text-black leading-tight mb-12">
              Value-Driven Approach
            </h2>
          </div>
          <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
            A well-managed refit can significantly improve a yacht's performance, usability, and market appeal. SYG Yachts approaches each project with a strategic lens — balancing owner objectives, technical considerations, and long-term value.
          </p>
        </div>
      </section>

      {/* Call to Action */}
      <section id="contact" className="py-32 px-8 lg:px-16 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-black mb-8 leading-tight">
            Plan a Refit Project
          </h2>
          <p className="text-lg md:text-xl text-gray-700 mb-12 leading-relaxed">
            Connect with our refit advisory team to discuss your project requirements.
          </p>
          <button 
            onClick={handleContactClick}
            className="inline-block px-12 py-5 bg-black text-white text-sm tracking-widest hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            SPEAK WITH A REFIT ADVISOR
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
